<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="uyeOl">Musteri Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="login"> Giriş
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="musteriListesi"> Muşteri List
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="musteriDurumGuncelle"> Musteri durum Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="musteriDetay"> Musteri Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="siparisTanimlama">Siparis Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="musteriSiparisListesi"> Musteri Siparis Listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="siparisListesi"> Siparis Listesi
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import musteriService from '../../../WSProvider/MusteriService';
    import notification from '../../../notification'
    let base64 = require('base64_js');
    let userData = "";
    export default {
        name: "MusteriDetay",
        methods: {
            uyeOl() {
                // let dil = [{
                //     dil: "en",
                //     baslik: "fbdb",
                //     altBaslik: "fddb",
                //     icerik: "gbhgfnbfg",
                //     seoBaslik: "ghnfg",
                //     seoIcerik: "fghn"
                // }];
                musteriService.uyeOl("dfgdf", "5325635635", "1997-15-09","fdfgdg@gmail.com","test");
            },
            login() {
                musteriService.login("test@gmail.com", "test");
            },
            musteriListesi() {
                musteriService.musteriListesi(1,0,10);
            },
            musteriDurumGuncelle() {
                // let updateList = [{
                //     type: "baslik",
                //     value: "nesnessb"
                // }];
                musteriService.musteriDurumGuncelle("MK-73005", 0);
            },
            musteriDetay() {
                musteriService.musteriDetay("MK-73005");
            },
            siparisListesi() {
                let dil = [{
                    dil: "en",
                    baslik: "dhfghf"
                }];
                musteriService.siparisListesi("hfghfh", 1,1,1,dil,["UK-73000"]);
            },
            musteriSiparisListesi() {
                musteriService.musteriSiparisListesi(0,10,"MK-73005");
            },
            siparisTanimlama() {
                let urunList = [{
                    urunId: 8,
                    fiyat: "55.00",
                    adet: 3,
                    aciklama: "nesnessb"
                }];
                musteriService.siparisTanimlama(1,"nesrin","54545",urunList);
            },

        }
    }
</script>

<style scoped>

</style>